import React, { useState } from 'react';
import { Modal, Input, message } from 'antd';

const { TextArea } = Input;

interface SimulationReasonModalProps {
  open: boolean;
  loading: boolean;
  onSubmit: (goodReason: string, badReason: string) => void;
  onCancel: () => void;
}

const SimulationReasonModal: React.FC<SimulationReasonModalProps> = ({
  open,
  loading,
  onSubmit,
  onCancel,
}) => {
  const [goodReason, setGoodReason] = useState('');
  const [badReason, setBadReason] = useState('');

  const handleOk = () => {
    if (!goodReason.trim()) {
      message.warning('GOOD（どこが良かったか）を入力してください');
      return;
    }
    if (!badReason.trim()) {
      message.warning('BAD（不安や懸念点）を入力してください');
      return;
    }
    onSubmit(goodReason.trim(), badReason.trim());
  };

  const handleCancel = () => {
    setGoodReason('');
    setBadReason('');
    onCancel();
  };

  const handleAfterClose = () => {
    setGoodReason('');
    setBadReason('');
  };

  return (
    <Modal
      title="なぜ査定候補になりますか？自由かつ詳細に記述ください。"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      afterClose={handleAfterClose}
      okText="登録"
      cancelText="キャンセル"
      confirmLoading={loading}
      okButtonProps={{ disabled: !goodReason.trim() || !badReason.trim() }}
      width={600}
    >
      <p style={{ color: '#9CA3AF', fontSize: 13, marginBottom: 20 }}>
        ※今後のAI学習に大きく活かされますのでできるだけ詳細に記載ください。
      </p>

      <div style={{ marginBottom: 20 }}>
        <label style={{ color: '#111827', fontWeight: 600, fontSize: 15, display: 'block', marginBottom: 8 }}>
          GOOD（どこが良かったですか？）
        </label>
        <TextArea
          value={goodReason}
          onChange={(e) => setGoodReason(e.target.value)}
          placeholder="例: 駅近で利便性が高い。築年数の割に管理状態が良好。"
          rows={4}
        />
      </div>

      <div>
        <label style={{ color: '#111827', fontWeight: 600, fontSize: 15, display: 'block', marginBottom: 8 }}>
          BAD（不安や懸念点はどこですか？）
        </label>
        <TextArea
          value={badReason}
          onChange={(e) => setBadReason(e.target.value)}
          placeholder="例: 1階で日当たりに不安。管理費が周辺相場より高め。"
          rows={4}
        />
      </div>
    </Modal>
  );
};

export default SimulationReasonModal;
